<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Result from '@/router/views/setting/maintenance/service/importResult'
import { Helper } from '@/mixin/helper'
import { IMPORT_SERVICE_SETTING } from '@/services/api/maintenance/serviceSchedules'
import { mapGetters } from 'vuex'
import McButton from '@/components/McButton'

export default {
  page: {
    title: 'Service',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Result,
    McButton,
  },
  mixins: [Helper],
  data() {
    return {
      file: null,
      fileProp: {
        name: null,
        size: 0,
        sizeProgress: 0,
        message: null,
        error: false,
        progressVal: 0,
      },
      showRemovedBtn: false,
      importResponse: false,
      responseData: {
        totalFailed: null,
        totalSuccess: null,
        totalData: null,
        errorFile: null,
        fileName: null,
        fileType: null,
      },
    }
  },
  computed: {
    title() {
      return this.$t('setting.list.maintenance.upload.componentService')
    },
    ...mapGetters({
      isWhitelabel: 'identity/isWhitelabel',
      isMetrack: 'identity/isMetrack',
    }),

    illustrationPathFile() {
      if (this.isWhitelabel() || this.isMetrack()) {
        return require(`@/assets/images/illustration/whitelabel/file.svg`)
      }
      return require(`@/assets/images/illustration/saas/file.svg`)
    },

    illustrationPathUploading() {
      if (this.isWhitelabel() || this.isMetrack()) {
        return require(`@/assets/images/illustration/whitelabel/uploading.svg`)
      }
      return require(`@/assets/images/illustration/saas/uploading.svg`)
    },
  },
  methods: {
    async fileChangeHandler(event) {
      const files = event.target.files
      this.file = files[0]
      this.fileProp.name = files[0].name
      this.fileProp.size = (files[0].size / (1024 * 1024)).toFixed(2)

      const input = {
        filebase64: null,
        filename: files[0].name,
      }

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = (error) => reject(error)
        })

      input.filebase64 = (await toBase64(files[0])).split(',')[1]

      if (
        files[0].type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        files[0].type === 'text/csv'
      ) {
        if (this.fileProp.size > 10) {
          this.fileProp.message = this.$t('license.text.tooLarge')
          this.fileProp.error = true
          return
        }
        this.fileProp.error = false
        this.showRemovedBtn = true

        const param = [15, 25, 50, 70, 90, 100]
        for (let i = 0; i < param.length; i++) {
          setTimeout(() => {
            this.fileProp.sizeProgress = ((this.fileProp.size * param[i]) / 100).toFixed(2)
            this.fileProp.progressVal = param[i]
            if (param[i] === 100) {
              setTimeout(() => {
                this.$apollo
                  .mutate({
                    mutation: IMPORT_SERVICE_SETTING,
                    variables: {
                      input: input,
                    },
                  })
                  .then((response) => {
                    if (response.data.importServiceSetting.isSuccessful) {
                      const res = response.data.importServiceSetting.importServiceSetting
                      this.importResponse = true
                      this.responseData.totalData = res.totalData
                      this.responseData.totalFailed = res.totalFailed
                      this.responseData.totalSuccess = res.totalSuccess
                      this.responseData.errorFile = res.errorFile
                      this.responseData.fileName = files[0].name
                      this.responseData.fileType = files[0].type
                    } else {
                      if (
                        response.data.importServiceSetting.message ==
                        'Error: "Incorrect File Used."'
                      ) {
                        this.fileProp.message = this.$t('license.text.template')
                        this.fileProp.error = true
                      } else {
                        return this.$mcToast.warning(response.data.importServiceSetting.message)
                      }
                    }
                  })
              }, 1000)
            }
          }, i * 500)
        }
      } else {
        this.fileProp.message = this.$t('license.text.incompatible')
        this.fileProp.error = true
      }
    },

    deleteFile() {
      this.importResponse = false
      this.file = null
      this.fileProp = {
        name: null,
        size: 0,
        sizeProgress: 0,
        message: null,
        error: false,
        progressVal: 0,
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" class="mc-page-three" />

      <p class="mb-4">{{ $t('setting.list.maintenance.upload.text') }}</p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButton
            variant="secondary"
            class="ms-3"
            :text="$t('global.back')"
            @click="$router.push({ name: 'Setting Service Activity' })"
          />
        </div>
      </div>
    </div>

    <div class="card" v-if="!importResponse">
      <div class="card-body">
        <div class="mc-upload d-flex justify-content-between">
          <div class="mc-upload__file">
            <div class="mc-upload__file-wrapper">
              <div class="mc-upload__file-area" v-if="fileProp.name == null">
                <input
                  id="inputfile"
                  ref="inputfile"
                  type="file"
                  @change="fileChangeHandler"
                  @drop="fileChangeHandler"
                  name="attachment"
                  class="mc-upload__file-area-input"
                  accept=".xlsx, .csv"
                />

                <div class="mc-upload__file-area-text">
                  <img :src="illustrationPathFile" alt />
                  <p>{{ $t('license.text.selectOrDrop') }}</p>
                  <p>({{ $t('license.text.maximum') }})</p>
                </div>
              </div>
              <div
                :class="`mc-upload__file-result ${
                  fileProp.error ? 'mc-upload__file-result--error' : null
                }`"
                v-else
              >
                <div class="mc-upload__file-result-wrapper">
                  <img :src="illustrationPathUploading" alt />
                  <h4 class="mc-upload__file-result-status">
                    {{ fileProp.message }}
                  </h4>
                  <div class="mc-upload__file-result-desc d-flex justify-content-between">
                    <span>{{ fileProp.name }}</span>
                    <span v-if="fileProp.error">
                      <i class="mc-fa icon-outline_trash-2" @click="deleteFile"></i>
                      <i class="mc-fa icon-fill_alert-triangle"></i>
                    </span>
                  </div>
                  <div class="mc-upload__file-result-progress">
                    <div :style="`width: ${fileProp.progressVal}%`"></div>
                  </div>
                  <span class="mc-upload__file-result-filesize">
                    <span>{{ fileProp.sizeProgress }} MB / </span>{{ fileProp.size }} MB
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="mc-upload__info">
            <div class="mc-upload__info-wrapper">
              <h3 class="mc-upload__info-title">
                <i class="mc-fa icon-outline_book"></i> {{ $t('license.object.guide') }}
              </h3>
              <ul class="mc-upload__info-list">
                <li>
                  <strong>{{ $t('license.object.downloadTemplate') }}</strong>
                  <p>
                    {{ $t('license.text.downloadTemplate') }}
                  </p>
                  <McButton
                    size="sm"
                    variant="primary"
                    icon="icon-outline_download"
                    :text="$t('license.object.downloadTemplate')"
                    href="https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/IMPORT-SERVICE-SETTING.xlsx"
                  />
                </li>
                <li>
                  <strong>{{ $t('license.object.copyData') }}</strong>
                  <p>
                    {{ $t('license.text.copyData') }}
                  </p>
                </li>
                <li>
                  <strong>{{ $t('license.object.uploadFile') }}</strong>
                  <p>
                    {{ $t('license.text.uploadFile1') }}
                    <b>.csv</b> {{ $t('global.object.or') }} <b>.xlsx</b>.
                    {{ $t('license.text.uploadFile2') }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Result
      v-else
      :totalFailed="responseData.totalFailed"
      :totalSuccess="responseData.totalSuccess"
      :totalData="responseData.totalData"
      :errorFile="responseData.errorFile"
      :fileName="responseData.fileName"
      :fileType="responseData.fileType"
    />
  </Layout>
</template>
